export const MANUAL = [
  {
    category: '',
    items: [
      {
        label: 'How to Create an Account',
      },
    ],
  },
  {
    category: 'Estimate and Quotes',
    items: [
      {
        label: 'Create a Estimate and Quote',
      },
      {
        label: 'Edit or Update an Estimate and Quote',
      },
      {
        label: 'Delete an Estimate and Quote',
      },
      {
        label: 'Duplicate an Estimate and Quote',
      },
      {
        label: 'Convert Estimate and Quote to Invoice',
      },
      {
        label: 'Approve an Estimate and Quote',
      },
      {
        label: 'Export Estimate and Quote to PDF',
      },
      {
        label: 'Search and View an Estimate and Quote',
      },
      {
        label: 'Send via Link or Email, and Download Estimates and Quotes',
      },
    ],
  },
  {
    category: 'Recurring Invoice',
    items: [
      {
        label: 'Create a Recurring Invoice',
      },
      {
        label: 'Edit or Update a Recurring Invoice',
      },
      {
        label: 'Search and Duplicate a Recurring Invoice',
      },
      {
        label: 'End a Recurring Invoice',
      },
      {
        label: 'Suspend a Recurring Invoice',
      },
    ],
  },
  {
    category: 'Invoice',
    items: [
      {
        label: 'Create an Invoice',
      },
      {
        label: 'Edit an Existing Invoice',
      },
      {
        label: 'Delete an Invoice',
      },
      {
        label: 'View an Existing Invoice',
      },
      {
        label: 'Duplicate an Invoice',
      },
      {
        label: 'Export Invoice to PDF',
      },
      {
        label: 'Record a Payment for an Invoice',
      },
      {
        label:
          'Send via Link or Email, and Download an Invoice Send via Link or Email, and Download an Invoice',
      },
      {
        label: 'Post an Invoice',
      },
      {
        label: 'Void an Invoice',
      },
    ],
  },
  {
    category: 'Customer',
    items: [
      {
        label: 'Create New Customer',
      },
      {
        label: 'Edit or Update Customer Information',
      },
      {
        label: 'Import Customer Data',
      },
      {
        label: 'Delete a Customer Record',
      },
      {
        label: 'Send a Customer Statement',
      },
      {
        label: 'View and Edit a Customer Record',
      },
    ],
  },
  {
    category: 'Category',
    items: [
      {
        label: 'Create a New Category',
      },
      {
        label: 'Search and Delete a Category',
      },
      {
        label: 'Search and Edit a Category',
      },
    ],
  },
  {
    category: 'Products and Services',
    items: [
      {
        label: 'Create New Product and Service',
      },
      {
        label: 'Search and Edit Product and Service',
      },
      {
        label: 'Search and Delete Products and Services',
      },
    ],
  },
  {
    category: 'Reports',
    items: [
      {
        label: 'View Aged Receivables Report',
      },
      {
        label: 'View Income by Customer',
      },
    ],
  },
  {
    category: 'Sales Tax',
    items: [
      {
        label: 'Create New Sales Tax',
      },
      {
        label: 'Search and Edit Sales Tax',
      },
      {
        label: 'Search and Delete a Sales Tax',
      },
    ],
  },
];

export const manualKey = (label: string): string => {
  return label
    .toUpperCase()
    .replace(/[^A-Z0-9\s]/g, '')
    .trim()
    .replace(/\s+/g, '_');
};

export const MANUALS_LOOKUP = Object.fromEntries(
  MANUAL.flatMap((cat) =>
    cat.items.map((item) => [
      manualKey(item.label),
      { label: item.label, category: cat.category },
    ])
  )
);
